export const DEFAULT_VOLTAGE_FOR_50 = 400;
export const DEFAULT_VOLTAGE_FOR_60 = 460;
